import { Api } from "./api";

let api: Api;

export const buildApi = (url: string) => {
    api = new Api(url);
    return api;
}

export const getApi = () => {
    return api;
}


// WEBPACK FOOTER //
// ./src/api/ApiProvider.ts